if (!customElements.get("m-brand-list")) {
  class MBrandList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      const wrapper = this.querySelector("[data-wrapper]");
      wrapper.classList.add("swiper-wrapper");
      this.initSlider(); this.bindWheelNav(this.querySelector(".swiper-container"));
    }

                                bindWheelNav(container) { if (!container || !this.slider) return; if (!this.slider._navLockPatched) { this.slider._navLockPatched = true; const _oN = this.slider.slideNext.bind(this.slider); const _oP = this.slider.slidePrev.bind(this.slider); const _sp = () => (this.slider.params.speed || 1000) + 50; this.slider.slideNext = (...a) => { if (this.slider._navLocked) return; this.slider._navLocked = true; _oN(...a); clearTimeout(this.slider._navLockTO); this.slider._navLockTO = setTimeout(() => { this.slider._navLocked = false; }, _sp()); }; this.slider.slidePrev = (...a) => { if (this.slider._navLocked) return; this.slider._navLocked = true; _oP(...a); clearTimeout(this.slider._navLockTO); this.slider._navLockTO = setTimeout(() => { this.slider._navLocked = false; }, _sp()); }; } this._wheelLocked = false; this._wheelTimeout = null; this.slider.on("slideChange", () => { clearTimeout(this._loopFixTO); this._loopFixTO = setTimeout(() => { if (this.slider) { this.slider.animating = false; this.slider.loopFix && this.slider.loopFix(); } }, (this.slider.params.speed || 1000) + 50); }); container.addEventListener("wheel", (e) => { const absX = Math.abs(e.deltaX); const absY = Math.abs(e.deltaY); if (absX <= absY || absX < 8) return; e.preventDefault(); if (this._wheelLocked) return; this._wheelLocked = true; if (e.deltaX > 0) { this.slider.slideNext(); } else { this.slider.slidePrev(); } clearTimeout(this._wheelTimeout); this._wheelTimeout = setTimeout(() => { this._wheelLocked = false; }, 700); }, { passive: false }); } initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const items = parseInt(this.dataset.items);
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 2,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true, loopAdditionalSlides: 6,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: items > 3 ? 3 : items,
            },
            1024: {
              slidesPerView: items,
            },
          },
        });
      }
    }
  }

  customElements.define("m-brand-list", MBrandList);
}
